import { getErrorMessage } from "../../../../helper/getResponseMessage";
import { showError, showSuccess } from "../../../../util/ShowStatus";
import axios from "../../../../util/axiosconfig";

export const fetchProjectNameMasterList = async (
  setProjectNames: any,
  toast: any,
) => {
  try {
    const response = await axios.get(
      `health-and-safety/oir-project-name-master-list`,
    );
    if (response.data && response.data.result) {
      setProjectNames(response.data.result);
    }
  } catch (err) {
    const error = getErrorMessage(err);
    showError(error, toast);
  }
};

export const fetchObservationTypeMasterList = async (
  setObservationTypes: any,
  toast: any,
) => {
  try {
    const response = await axios.get(
      `health-and-safety/oir-observation-type-master-list`,
    );
    if (response.data && response.data.result) {
      setObservationTypes(response.data.result);
    }
  } catch (err) {
    const error = getErrorMessage(err);
    showError(error, toast);
  }
};

export const fetchAmelioDepartmentMasterList = async (
  setDepartments: any,
  toast: any,
) => {
  try {
    const response = await axios.get(
      `health-and-safety/oir-amelio-department-name-master-list`,
    );
    if (response.data && response.data.result) {
      setDepartments(response.data.result);
    }
  } catch (err) {
    const error = getErrorMessage(err);
    showError(error, toast);
  }
};

export const fetchAllObserveInformReports = async (
  setReports: any,
  setLoading: any,
  filters: any,
  toast: any,
  type?: string,
  setExportLoading?: any,
) => {
  try {
    const params: any = {};
    if (filters && filters.startDate && filters.endDate) {
      params.startDate = filters.startDate;
      params.endDate = filters.endDate;
    }
    if (type === "export") {
      setExportLoading(true);
      const response = await axios.get(
        `health-and-safety/export-oir-forms-to-excel`,
        {
          params,
          responseType: "blob", // Important for binary data
        },
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.download = "OIR_report.csv";

      // Append to body and trigger download
      document.body.appendChild(link);
      link.click();

      // Clean up
      link.parentNode?.removeChild(link);
      window.URL.revokeObjectURL(url);
      setExportLoading(false);
    } else {
      setLoading(true);
      const response = await axios.get(
        `health-and-safety/observe-inform-report-form`,
        {
          params,
        },
      );
      setReports(response.data.result);
      setLoading(false);
    }
  } catch (err) {
    const error = getErrorMessage(err);
    setLoading(false);
    if (setExportLoading) setExportLoading(false);
    showError(error, toast);
  }
};

export const getObserveInformReportById = async (
  setFormData: any,
  setFormDataLoading: any,
  formIDParam: number,
  navigate: any,
  toast: any,
) => {
  try {
    setFormDataLoading(true);
    const response = await axios.get(
      `health-and-safety/observe-inform-report-form-by-id?formID=${formIDParam}`,
    );
    if (!response.data.result || response.data.result.length === 0) {
      showError("Form not found", toast);
      setFormDataLoading(false);
      navigate("/layout/health-and-safety/observe-inform-report");
      return;
    }
    setFormData(response.data.result);
    setFormDataLoading(false);
  } catch (err) {
    const error = getErrorMessage(err);
    setFormDataLoading(false);
    showError(error, toast);
  }
};

export const generateQRCode = async (
  setQRCodeData: any,
  setQRLoading: any,
  toast: any,
  frontendFormUrl: string,
  logoUrl: string = "https://storage.amelio-group.com/amelio/amelioLogo/amelio-blue-img.png",
) => {
  try {
    setQRLoading(true);
    const response = await axios.get(
      `health-and-safety/generate-observe-inform-report-qr`,
      {
        params: {
          frontendFormUrl,
          logoUrl,
        },
      },
    );
    setQRCodeData(response.data.result);
    setQRLoading(false);
    return response.data.result;
  } catch (err) {
    const error = getErrorMessage(err);
    setQRLoading(false);
    showError(error, toast);
    return null;
  }
};

export const submitObserveInformReport = async (
  formValues: any,
  photos: File[],
  toast: any,
  setSubmitting: any,
  navigate: any,
  isPublicSubmission: boolean = false,
) => {
  try {
    setSubmitting(true);
    const formData = new FormData();
    formData.append("formJson", JSON.stringify(formValues));
    formData.append("isWeb", "true");

    // Append each photo to the FormData
    photos.forEach((photo) => {
      formData.append("photos", photo);
    });

    const response = await axios.post(
      "health-and-safety/observe-inform-report-form",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );

    setSubmitting(false);
    showSuccess(response.data.Message || "Form submitted successfully", toast);

    if (!isPublicSubmission) {
      navigate("/layout/health-and-safety/observe-inform-report");
    }

    return true;
  } catch (err) {
    const error = getErrorMessage(err);
    setSubmitting(false);
    showError(error, toast);
    return false;
  }
};

export const exportObserveInformReportsToExcel = async (
  filters: any,
  toast: any,
  setExporting: any,
) => {
  try {
    setExporting(true);
    const params: any = {};
    if (filters && filters.startDate && filters.endDate) {
      params.startDate = filters.startDate;
      params.endDate = filters.endDate;
    }

    const response = await axios.get(
      `health-and-safety/export-observe-inform-reports`,
      {
        params,
        responseType: "blob",
      },
    );

    // Create blob link to download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      `Observe_Inform_Reports_${new Date().toISOString().split("T")[0]}.xlsx`,
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    setExporting(false);
    showSuccess("Export completed successfully", toast);
  } catch (err) {
    const error = getErrorMessage(err);
    setExporting(false);
    showError(error, toast);
  }
};
